module.exports = __webpack_public_path__ + "static/img/HT2-max.f994b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refs/ht/HT2-max.jpg
// module id = WsbB
// module chunks = 0